import ManagementReportScreen from './ManagementReportScreen.js';

export default ManagementReportScreen;
